import React from "react";
import {getFullName} from "./ownLoanHistoryUtility";
import {truncateString} from "../../../../Utilities/commonUtilities";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface OwnLoanHistoryRowProps {
    ownLoanHistoryItem: Record<string, any>;
}

export const OwnLoanHistoryRow = ({
                                      ownLoanHistoryItem
                                  }: OwnLoanHistoryRowProps) => {

    return (
        <tr id={ownLoanHistoryItem.ownLoanItemId}>
            <td>
                {ownLoanHistoryItem.ownCatalogItem.title}
            </td>
            <td>
                {getFullName(ownLoanHistoryItem.patron)}
            </td>
            <td>
                {ownLoanHistoryItem.districtName}
            </td>
            <td>
                {ownLoanHistoryItem.organization}
            </td>
            <td>
                {ownLoanHistoryItem.shippingLocation.name}
            </td>
            <td>
                {ownLoanHistoryItem.dateFulfilledFormatted}
            </td>
            <td>
                {ownLoanHistoryItem.ownLoanStatusText}
            </td>
            <td>{
                isAdmin() &&
                truncateString(ownLoanHistoryItem.ownLoanNotes)
            }
            </td>
        </tr>
    );
};
